import fetch from "@elsa-zku/lib/helpers/fetch";
import { localStorage } from "@elsa-zku/lib/helpers/localStorage";
import { CancellablePromise } from "@elsa-zku/lib/interfaces/api";

export let _apiUrl = `${process.env.API_URL}/api/`;
let _debugToken = localStorage.get("DEBUG_TOKEN") || null;

export default <R extends { data: any } | void>(
  ...args: Parameters<typeof fetch>
): CancellablePromise<R extends { data: any } ? R["data"] : R> => {
  args[1] = _apiUrl + args[1];
  if (_debugToken) {
    args[3] = args[3]
      ? { ...args[3], headers: args[3].headers ? { ...args[3].headers, debug: _debugToken } : { debug: _debugToken } }
      : { headers: { debug: _debugToken } };
  }
  return fetch<R>(...args).then(
    (response) => (response ? response.data : response),
    (error) => Promise.reject(error.error.errors),
  );
};
